import { doPost, toUrl } from "./lib.js";
import { receiveResolutionJob, receiveIdentities, receiveProposals, } from "./schemas.js";
async function posterChild(action, clientInfo, input) {
    const url = toUrl(clientInfo.orgId, `resolution/${action}`);
    const json = await doPost(url, clientInfo, input);
    return receiveResolutionJob().parse(json);
}
export const pollResolution = (clientInfo, input) => posterChild("poll", clientInfo, input);
export const submitResolution = (clientInfo, input) => posterChild("submit", clientInfo, input);
export async function identities(clientInfo, _input) {
    const url = toUrl(clientInfo.orgId, "resolution/identities");
    const json = await doPost(url, clientInfo, {});
    return receiveIdentities().parse(json);
}
export async function proposals(clientInfo, _input) {
    const url = toUrl(clientInfo.orgId, "resolution/proposals");
    const json = await doPost(url, clientInfo, {});
    return receiveProposals().parse(json);
}
